import api from '@/api'

const state = {
  userData: {
    user: {
      id: null
    }
  },
  userProfile: {}
}
const actions = {
  getCurrentUser: ({ commit }) => {
    const data = localStorage.getItem('user_data')
    if (data) commit('setUserData', JSON.parse(data))
  },
  removeUserData: ({ commit }) => {
    commit('setUserData', { user: { id: null } })
  },
  getProfile({ commit }) {
    return new Promise((resolve, reject) => {
      api.auth.profile().then(
        response => {
          commit('setUserProfile', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateProfile({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.auth.updateProfile(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  login({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.auth.login(payloads).then(
        response => {
          commit('setUserData', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  resetPassword({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.auth.resetPassword(payloads).then(
        response => {
          commit('setUserData', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  changePassword({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.auth.changePassword(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  forgotPassword({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.auth.forgotPassword(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  logout({ dispatch }) {
    return new Promise((resolve, reject) => {
      api.auth.logout().then(
        response => {
          localStorage.removeItem('order_shipping')
          localStorage.removeItem('order_logistic')
          localStorage.removeItem('order')
          dispatch('removeUserData')
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setUserData(state, value) {
    state.userData = value
    localStorage.removeItem('user_data')
    localStorage.setItem('user_data', JSON.stringify(value))
  },
  setUserProfile(state, value) {
    state.userProfile = value
  }
}
const getters = {
  userData: state => state.userData,
  isLoggedIn: state => (state && state.userData ? state.userData.user.id !== null : false),
  userProfile: state => state.userProfile
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
